/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserRoleRelationVm
 */
export interface UserRoleRelationVm {
    /**
     * 
     * @type {string}
     * @memberof UserRoleRelationVm
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRoleRelationVm
     */
    roleId?: string;
}

export function UserRoleRelationVmFromJSON(json: any): UserRoleRelationVm {
    return UserRoleRelationVmFromJSONTyped(json, false);
}

export function UserRoleRelationVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserRoleRelationVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'roleId': !exists(json, 'roleId') ? undefined : json['roleId'],
    };
}

export function UserRoleRelationVmToJSON(value?: UserRoleRelationVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'roleId': value.roleId,
    };
}


